import { UiStringsEn } from '@/translations/UiStringsEn';
import { UiStringsRu } from '@/translations/UiStringsRu';
import { UiStringsEs } from '@/translations/UiStringsEs';
import { UiStringsAr } from '@/translations/UiStringsAr';
import { LANGUAGES, NATIVE_LANGUAGES } from '@/lib/constants';

export const getUiStringsForServer = (language: string) => {
    if (language === LANGUAGES.english.name) {
        return UiStringsEn;
    } else if (language === NATIVE_LANGUAGES.russian.name) {
        return UiStringsRu;
    } else if (language === LANGUAGES.spanish.name) {
        return UiStringsEs;
    } else if (language === NATIVE_LANGUAGES.arabic.name) {
        return UiStringsAr;
    }

    return UiStringsEn;
};
